import ChartContainer from '../Services/charts/apex-charts/ChartContainer';
import useLineChart from './hooks/useLineChart';

export const Line = ({
    title,
    values,
    subtitles,
    percentual = false,
    className = '',
    height = 350,
    category,
    decimals = 2
}) => {
    const { chartConfig } = useLineChart({
        values,
        subtitles,
        category,
        percentual,
        decimals
    });

    return (
        <ChartContainer
            title={title}
            options={chartConfig}
            series={chartConfig.series}
            type="line"
            height={height}
            className={`${className}`}
        />
    );
};
